export default "__VITE_ASSET__Bgmx7OWu__"